import { render, staticRenderFns } from "./SallySearchBox.vue?vue&type=template&id=554cfc75&scoped=true"
import script from "./SallySearchBox.vue?vue&type=script&lang=js"
export * from "./SallySearchBox.vue?vue&type=script&lang=js"
import style0 from "./SallySearchBox.vue?vue&type=style&index=0&id=554cfc75&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554cfc75",
  null
  
)

export default component.exports